import React, { useMemo, MutableRefObject, Ref } from 'react'
import { useTranslation } from 'react-i18next'
import PersistentMenu from '../../persistentMenu/PersistentMenu'

import { PrevIcon } from '../../../icons/Icons'
import {initialIframeSetting} from '../../../app/config'
import {
  BotInfoHolder,
  CloseIframeButton,
  HeaderAvatar,
  LeftHolder,
  RightHolder,
  HeaderTitle,
  HeaderWrapper,
  HeaderTextContainer,
  HeaderSubTitle
} from './Header.style'
import { palette } from '../../../theme/palette'
import { IframeSettingsType } from '../../../models/IframeSettingsType'
import { SettingsType } from '../../../models/SettingsType'
import { PersistentMenuType } from '../../../models/PersistentMenuType'

interface Props {
  isPanoramaPost: boolean
  isEmpowerPost: boolean
  setIframe: (p: IframeSettingsType) => void
  isUserIdle: boolean
  isMaximized: boolean
  device: object
  postMessage: (msg: any) => any
  iframeSettings: IframeSettingsType
  persistentMenu: PersistentMenuType
  setIsScrollChat: (props: boolean) => void
  setClickableChat: Function
  isCloseWidgetModalOpened: boolean
  settings: SettingsType
  anchorMenu: object
  setAnchorMenu: (props: boolean) => void
  isIframeContentLoaded: boolean
  setIsIframeContentLoaded: (props: boolean) => void
  setIsLoadingIframeData: (props: boolean) => void
  isLoadingIframeData: boolean
  persistentMenuButtonRef: MutableRefObject<HTMLButtonElement>
  updateDisablingButtonsByPersistentMenuUse: () => void
  textMessageRef: Ref<{ resetRating: () => void }>
}

const Header: React.FC<Props> = ({
  isPanoramaPost,
  isEmpowerPost,
  setIframe,
  isUserIdle,
  isMaximized,
  device,
  postMessage,
  iframeSettings,
  persistentMenu,
  setIsScrollChat,
  setClickableChat,
  isCloseWidgetModalOpened,
  settings,
  anchorMenu,
  setAnchorMenu,
  isIframeContentLoaded,
  setIsIframeContentLoaded,
  setIsLoadingIframeData,
  isLoadingIframeData,
  persistentMenuButtonRef,
  updateDisablingButtonsByPersistentMenuUse,
  textMessageRef
}) => {
  const {logo, color, avatarDisplayPosition, widgetName, widgetSubName} = settings

  const needCloseIframeBtn = useMemo(() => {
    const {opportunityToManualClose, isLoaded} = iframeSettings
    return isLoaded && opportunityToManualClose && isIframeContentLoaded && isLoadingIframeData
  }, [iframeSettings, (isPanoramaPost && isIframeContentLoaded), isLoadingIframeData])

  const { t } = useTranslation()

  const hasHeaderAvatar = ['HEADER', 'HEADER_AND_CHAT'].includes(avatarDisplayPosition) && !needCloseIframeBtn

  const handleCloseIframe = () => {
    if (iframeSettings.isQuestionnaireIframeOpened) {
      const copyIframeSettings = Object.assign({}, iframeSettings)
      copyIframeSettings.isQuestionnaireIframeOpened = false
      setIframe(copyIframeSettings)
    } else {
      const copyIframeSettings = Object.assign({}, initialIframeSetting)
      copyIframeSettings.questionnaireName = iframeSettings.questionnaireName
      setIframe(copyIframeSettings)
      setIsIframeContentLoaded(false)
      setIsLoadingIframeData(false)
    }
  }

  return (
    <HeaderWrapper color={color}>
      <LeftHolder>
        {needCloseIframeBtn && (
          <CloseIframeButton aria-label={t('close_iframe')} onClick={handleCloseIframe}>
            <PrevIcon color={palette.white} />
          </CloseIframeButton>
        )}
      </LeftHolder>
      <BotInfoHolder>
        {hasHeaderAvatar && <HeaderAvatar src={logo} />}
        <HeaderTextContainer>
          <HeaderTitle>
            {widgetName}
            <HeaderSubTitle>{widgetSubName}</HeaderSubTitle>
          </HeaderTitle>
        </HeaderTextContainer>
      </BotInfoHolder>
      <RightHolder>
        {(persistentMenu && persistentMenu.callToActions.length) && (
          <PersistentMenu
            isUserIdle={isUserIdle}
            isPanoramaPost={isPanoramaPost}
            isEmpowerPost={isEmpowerPost}
            iframeSettings={iframeSettings}
            setIframe={setIframe}
            isMaximized={isMaximized}
            device={device}
            persistentMenu={persistentMenu}
            setIsScrollChat={setIsScrollChat}
            setClickableChat={setClickableChat}
            isCloseWidgetModalOpened={isCloseWidgetModalOpened}
            postMessage={(message) => postMessage(message)}
            anchorMenu={anchorMenu}
            setAnchorMenu={setAnchorMenu}
            setIsLoadingIframeData={setIsLoadingIframeData}
            persistentMenuButtonRef={persistentMenuButtonRef}
            updateDisablingButtonsByPersistentMenuUse={updateDisablingButtonsByPersistentMenuUse}
            textMessageRef={textMessageRef}
          />
        )}
      </RightHolder>
    </HeaderWrapper>
  )
}

export default Header
